/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconApple(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M10.37 2.555c.492-.598.84-1.415.84-2.24A1.87 1.87 0 0 0 11.186 0c-.809.032-1.779.534-2.353 1.213-.46.517-.881 1.342-.881 2.166 0 .13.024.251.032.292.049.008.13.024.218.024.72 0 1.625-.485 2.167-1.14zm.565 1.31c-1.205 0-2.19.735-2.822.735-.67 0-1.544-.687-2.595-.687-1.997 0-4.018 1.65-4.018 4.754 0 1.94.744 3.986 1.674 5.304C3.966 15.086 4.66 16 5.664 16c.986 0 1.423-.655 2.652-.655 1.245 0 1.528.639 2.62.639 1.082 0 1.802-.995 2.49-1.973.76-1.124 1.083-2.215 1.09-2.272-.064-.016-2.134-.865-2.134-3.234 0-2.053 1.625-2.975 1.722-3.048-1.075-1.544-2.716-1.592-3.169-1.592z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M15.195 4.513c.678-.823 1.156-1.946 1.156-3.08 0-.155-.01-.31-.033-.433-1.112.044-2.446.734-3.235 1.668-.634.711-1.212 1.845-1.212 2.979 0 .178.034.344.045.4.066.011.178.033.3.033.99 0 2.234-.667 2.979-1.567zm.778 1.8c-1.656 0-3.012 1.012-3.88 1.012-.922 0-2.123-.945-3.568-.945C5.779 6.38 3 8.648 3 12.918c0 2.668 1.023 5.48 2.301 7.293C6.391 21.744 7.347 23 8.725 23c1.356 0 1.957-.9 3.646-.9 1.712 0 2.101.878 3.602.878 1.49 0 2.48-1.368 3.424-2.713 1.045-1.545 1.49-3.046 1.5-3.123-.088-.023-2.934-1.19-2.934-4.447 0-2.824 2.235-4.091 2.368-4.191-1.479-2.123-3.735-2.19-4.358-2.19z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconApple is deprecated and will be archived soon. Use IconApple instead.
 */
export function Experimental__IconApple(props) {
  return /*#__PURE__*/React.createElement(IconApple, props);
}